import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaGlobeAsia, FaEye, FaEyeSlash, FaSignInAlt } from 'react-icons/fa';
import { authAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import './Auth.css';

const Login = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await authAPI.login(form);
      login(res.data.token, res.data.user);
      toast.success(`Welcome back, ${res.data.user.name}!`);
      navigate(res.data.user.role === 'admin' ? '/admin' : '/jobs');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-left">
        <div className="auth-left-content">
          <div className="auth-brand">
            <div className="auth-brand-icon"><FaGlobeAsia /></div>
            <div>
              <div className="auth-brand-name">Pavishna</div>
              <div className="auth-brand-sub">Global Services</div>
            </div>
          </div>
          <h2>Your Journey to International Success Starts Here</h2>
          <p>Join thousands of professionals who found their dream jobs abroad through Pavishna Global Services.</p>
          <div className="auth-countries">
            {['🇦🇪 UAE', '🇸🇦 Saudi', '🇶🇦 Qatar', '🇰🇼 Kuwait', '🇧🇭 Bahrain', '🇴🇲 Oman', '🇸🇬 Singapore', '🇲🇾 Malaysia', '🇱🇾 Libya'].map(c => (
              <span key={c} className="auth-country-tag">{c}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-card">
        <div className="auth-card-header">
  <Link to="/" className="back-home-link">← Back to Home</Link>
  <h1>Welcome Back</h1>
  <p>Sign in to your account to explore opportunities</p>
</div>

         

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email" className="form-control"
                value={form.email} onChange={e => setForm({...form, email: e.target.value})}
                required placeholder="your@email.com"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <div className="pass-wrap">
                <input
                  type={showPass ? 'text' : 'password'} className="form-control"
                  value={form.password} onChange={e => setForm({...form, password: e.target.value})}
                  required placeholder="Enter your password"
                />
                <button type="button" className="toggle-pass" onClick={() => setShowPass(!showPass)}>
                  {showPass ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
            <button type="submit" className="btn-primary auth-submit" disabled={loading}>
              {loading ? 'Signing In...' : <><FaSignInAlt /> Sign In</>}
            </button>
          </form>

          <div className="auth-footer">
            Don't have an account? <Link to="/register">Register here</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
